import {
  Typography
} from '@mui/material';
import { format, parseISO } from 'date-fns';

const DataTimeDisplay = ({ config }) => {
  if (config.mode === 'ADAPTER_DEFAULT') {
    return <Typography variant="body2">Using adapter default configuration</Typography>;
  }
  
  if (config.mode === 'RELATIVE') {
    return (
      <Typography variant="body2">
        Last {config.relativeValue} {config.relativeUnit.toLowerCase()}
        {config.relativeValue > 1 ? 's' : ''}
        {config.granularity && ` (${config.granularity.toLowerCase()} granularity)`}
      </Typography>
    );
  }
  
  if (config.mode === 'ABSOLUTE') {
    const start = parseISO(config.startDateTime);
    const end = parseISO(config.endDateTime);
    
    return (
      <>
        <Typography variant="body2">
          From: {format(start, 'PPP')}
        </Typography>
        <Typography variant="body2">
          To: {format(end, 'PPP')}
        </Typography>
        {config.granularity && (
          <Typography variant="body2">
            Granularity: {config.granularity.toLowerCase()}
          </Typography>
        )}
      </>
    );
  }
};

export default DataTimeDisplay;